import React from "react";
import "../css/patientCard.css";
// import NameAvatar from "./NameAvatar";
import { useNavigate, useSearchParams } from "react-router-dom";
import moment from "moment";
import {
  isValidUrl,
  truncateString,
} from "../../new_appointment/_helper/utils.js/utils";
import { IoInformationCircleOutline } from "react-icons/io5";
import { getImageURL } from "../../_helper/utils/image";
const PatientCard = ({ data, handlePatientDetails }) => {
  const [searchParams] = useSearchParams();
  const allClinic = searchParams.get("all_clinic");
  const navigate = useNavigate();
  // //("!data?.profile_image---", data?.profile_image);

  const mainColorStyle = { backgroundColor: "var(--main-color)" };

  return (
    <div
      className="cu-all-patient-card-main relative"
      onClick={() =>
        // navigate(`/new/all-patient/${data?.id}?option=profile&all_clinic=${allClinic}`)
        handlePatientDetails(data?.id)
      }
    >
      <div className="cu-all-patient-img">
        {!data?.profile_image ||
        !isValidUrl(getImageURL(data?.profile_image)) ? (
          <div
            className="w-full h-full text-5xl text-white font-bold flex justify-center items-center uppercase"
            style={mainColorStyle}
          >
            {data?.full_name?.split("")[0]}
          </div>
        ) : (
          <img
            style={{ width: "100%", height: "100%" }}
            src={getImageURL(data?.profile_image)}
            alt=""
          />
        )}
      </div>
      <div className="cu-patient-card-details-div">
        <div className="cu-patient-card-name font-bold">
          {truncateString(data?.full_name, 20)}
        </div>
        <div className="cu-patient-othter-details">
          {moment().diff(data?.dob, "years")} Years
        </div>
        <div className="cu-patient-othter-details">{data?.phone}</div>
      </div>
      <div className="absolute top-1 right-1">
        {!data?.user?.email?.includes("gmail.com") ? (
          <IoInformationCircleOutline size={15} />
        ) : (
          ""
        )}
      </div>
    </div>
  );
};

export default PatientCard;
